import Axios from "axios";
// import AsyncStorage from "@react-native-community/async-storage";
import { AuthAction } from "../../store/actions";
import { Plant_Store } from "../../store";
// import { NavigationService } from "..";
import variables from "../variables";
import info from "../../components/info";
const { baseUrl } = variables;

Axios.interceptors.response.use(
  (response) => {
    return response;
  },
  ({ response }) => {
    console.log(response);
    if (response.status == 401) {
      try {
        // window.localStorage.clear();


        Plant_Store.dispatch(AuthAction.SignoutSuccess());
        // NavigationService.reset_0("SignIn")
        // window.location.reload();


        console.log("%c{Error 401}", "color: red", response);
      } catch (err) { }
    }
    if (response.status == 422) {
      try {
        Object.keys(response.data.errors).map((item) => {
          if (
            response.data.errors[item] !==
            "zipcode entered is not a valid US zipcode"
          ) {
            return info("error", `${item} ${response.data.errors[item]}`);
          }
        });
      } catch (err) { }
    }
    if (response.status == 400) {
      try {
        Object.keys(response.data.errors).map((item) => {
          // console.log('errorMSSG==>',)
          if(response.data.errors[item][0]!=="invalid authorization code"){
            return info("error", `${item} ${response.data.errors[item]}`);

          }
        });
      } catch (err) { }
    }
    return response;
  }
);
Axios.interceptors.request.use(
  function (config) {
    if (localStorage.getItem("access_token")) {
      config.headers = {
        ...config?.headers,
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "POST, GET, OPTIONS, PATCH, DELETE",
        // Authorization: "Bearer sk_test_NNyixqopBsFDglopAkCwvFrN",
        Authorization: config.headers.abc
          ? "Bearer sk_test_NNyixqopBsFDglopAkCwvFrN"
          : localStorage.getItem("access_token"),
      };
      return config;
    } else {
      return config;
    }
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

export default class ApiCaller {
  static Get = (endPoint = "", headers = {}, customUrl = "") => {
    if (headers["user_id"]) {
      headers["user-id"] = headers["user_id"];
      headers["access_token"] = headers["access_token"];
    }
    return Axios.get(customUrl ? customUrl : `${baseUrl}${endPoint}`, {
      headers: {
        "Content-Type": "application/json",
        client_id: "web_app",
        client_secret: "webapp123",
        ...headers,
      },
    })
      .then((res) => res)
      .catch((err) => err.response);
  };

  static Post = (endPoint = "", body = {}, headers = {}) => {
    if (headers["user_id"]) {
      headers["user-id"] = headers["user_id"];
      headers["access_token"] = headers["access_token"];
    }
    return Axios.post(`${baseUrl}${endPoint}`, body, {
      headers: {
        "Content-Type": "application/json",
        client_id: "web_app",
        client_secret: "webapp123",
        ...headers,
      },
    })
      .then((res) => res)
      .catch((err) => err.response);
  };

  static Put = (endPoint = "", body = {}, headers = {}) => {
    if (headers["user_id"]) {
      headers["user-id"] = headers["user_id"];
      headers["access_token"] = headers["access_token"];
    }
    return Axios.put(`${baseUrl}${endPoint}`, body, {
      headers: {
        "Content-Type": "application/json",
        client_id: "web_app",
        client_secret: "webapp123",
        ...headers,
      },
    })
      .then((res) => res)
      .catch((err) => err.response);
  };

  static Delete = (endPoint = "", headers = {}, body = {}) => {
    if (headers["user_id"]) {
      headers["user-id"] = headers["user_id"];
      headers["access_token"] = headers["access_token"];
    }
    return Axios.delete(`${baseUrl}${endPoint}`, {
      headers: {
        "Content-Type": "application/json",
        client_id: "web_app",
        client_secret: "webapp123",
        ...headers,
      },
      data: body,
    })
      .then((res) => res)
      .catch((err) => err.response);
  };
  static Patch = (endPoint = "", headers = {}, body = {}) => {
    if (headers["user_id"]) {
      headers["user-id"] = headers["user_id"];
      headers["access_token"] = headers["access_token"];
    }
    return Axios.patch(`${baseUrl}${endPoint}`, {
      headers,
      data: body,
    })
      .then((res) => res)
      .catch((err) => err.response);
  };
}
